import {
  NAME,
  VIDEO_THUMBNAIL_URL,
  VIEWABILITY_AND_BRAND_SAFETY_OPTION,
  VIEWABILITY_POSTBID_PARTNER,
  VIEWABILITY_VAST_URL,
  BRAND_SAFETY_POSTBID_PARTNER,
  BRAND_SAFETY_VAST_URL,
  IAS,
  IDENTITY,
  IDENTITY_ID,
  IDENTITY_NAME,
  identityTypes
} from './fields'

import { AD_TEXT, CALL_TO_ACTION, LANDING_PAGE_URL, VIDEO } from '../../fields'
import { FILE_ID } from '../../../../ReusableFormFields/AdFileUpload/fields'
import { OPTION_YES } from '../../../../../constants/forms'
import { IS_QUARANTINE } from '../../../../reusableFields'

export const transformValuesToBE = ({
  values,
  account,
  campaignId,
  lineItemId,
  rightsHolderId,
  isInternalAdCreation
}) => {
  // Initialize object to store viewability and brand safety settings
  const viewabilityAndBrandSafetyData = {}

  // Process viewability settings if enabled and a partner is selected
  if (values[VIEWABILITY_AND_BRAND_SAFETY_OPTION] === OPTION_YES && values[VIEWABILITY_POSTBID_PARTNER]) {
    viewabilityAndBrandSafetyData['viewability_postbid_partner'] = values[VIEWABILITY_POSTBID_PARTNER]

    // Add VAST URL only if IAS is selected as the viewability partner
    if (values[VIEWABILITY_POSTBID_PARTNER] === IAS && values[VIEWABILITY_VAST_URL]) {
      viewabilityAndBrandSafetyData[VIEWABILITY_VAST_URL] = values[VIEWABILITY_VAST_URL].trim()
    }
  }

  // Process brand safety settings if enabled and a partner is selected
  if (values[VIEWABILITY_AND_BRAND_SAFETY_OPTION] === OPTION_YES && values[BRAND_SAFETY_POSTBID_PARTNER]) {
    viewabilityAndBrandSafetyData['brand_safety_postbid_partner'] = values[BRAND_SAFETY_POSTBID_PARTNER]

    // Add VAST URL only if IAS is selected as the brand safety partner
    if (values[BRAND_SAFETY_POSTBID_PARTNER] === IAS && values[BRAND_SAFETY_VAST_URL]) {
      viewabilityAndBrandSafetyData[BRAND_SAFETY_VAST_URL] = values[BRAND_SAFETY_VAST_URL].trim()
    }
  }

  return {
    advertiser_id: account,
    campaign_id: campaignId,
    adgroup_id: lineItemId,
    creatives: [
      {
        ad_format: 'SINGLE_VIDEO',
        name: values[NAME],
        [IDENTITY_ID]: values[IDENTITY].external_id,
        [IDENTITY_NAME]: values[IDENTITY].name,
        identity_type: identityTypes.BC_AUTH_TT, // hardcoded
        [CALL_TO_ACTION]: values[CALL_TO_ACTION],
        landing_page_url: values[LANDING_PAGE_URL]?.trim(),
        ad_text: values[AD_TEXT],
        [VIDEO]: values[FILE_ID],
        image_urls: [values[VIDEO_THUMBNAIL_URL]],
        // Include viewability and brand safety settings if provided
        ...viewabilityAndBrandSafetyData
      }
    ],

    // isInternalAdCreation is default, also allow to pass it manually if user has ability to select it(values[IS_QUARANTINE])
    ...((isInternalAdCreation || values[IS_QUARANTINE]) && {
      quarantine: true,
      ...(rightsHolderId && { account_id: rightsHolderId, rights_holder_account_id: rightsHolderId })
    })
  }
}
